import { z } from 'zod'

export const pedidoSchema = z.object({
  produtoId: z.number({
    required_error: 'Selecione um produto',
    invalid_type_error: 'Produto inválido',
  }),
  codigoProduto: z.number().optional(),
  produto: z.string().min(1, 'Selecione um produto'),
  cor: z.string().min(1, 'Selecione uma cor'),
  corHex: z.string().optional(),
  gravacao: z.string().min(1, 'Tipo de gravação é obrigatório'),
  impressaoId: z.number({
    required_error: 'ID de impressão é necessário',
    invalid_type_error: 'ID de impressão inválido',
  }),
  quantidade: z
    .string()
    .min(1, 'Informe a quantidade')
    .refine(
      (val) => {
        const num = Number(val.replace(/\./g, '').replace(',', '.'))
        return !isNaN(num) && num > 0
      },
      {
        message: 'Quantidade deve ser um número válido maior que zero',
      }
    ),
  valorUnitario: z.number().positive('Valor unitário deve ser maior que zero'),
  subTotal: z
    .number()
    .positive('Subtotal deve ser maior que zero')
    .refine((val) => val > 0, {
      message: 'Subtotal deve ser maior que zero',
    }),
  observacao: z.string().min(5, 'Descrição muito curta, adicione mais detalhes'),
  // Validação para arquivos
  logoFile: z
    .any()
    .refine((file) => file instanceof File, {
      message: 'Upload do logo é obrigatório',
    })
    .refine((file) => file instanceof File && file.size <= 5 * 1024 * 1024, {
      message: 'Logo deve ter no máximo 5MB',
    }),
  layoutFile: z
    .any()
    .refine((file) => file instanceof File, {
      message: 'Upload do layout é obrigatório',
    })
    .refine((file) => file instanceof File && file.size <= 5 * 1024 * 1024, {
      message: 'Layout deve ter no máximo 5MB',
    }),
})

export function formatQuantidadeParaExibicao(valor) {
  if (!valor) return ''

  // Remove pontos e substitui vírgulas por pontos para processo numérico
  const numero = parseFloat(valor.toString().replace(/\./g, '').replace(',', '.'))
  if (isNaN(numero)) return valor

  // Formata o número com pontos como separadores de milhar
  return numero.toLocaleString('pt-BR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
}

export function formatQuantidadeParaCalculos(valor) {
  if (!valor) return 0

  // Remove pontos e substitui vírgulas por pontos
  const numero = Number(valor.toString().replace(/\./g, '').replace(',', '.'))
  return isNaN(numero) ? 0 : numero
}
